import {
  Auth0Connection,
  Auth0Setting,
  AuthenticationSocialProvider
} from './auth0';

/**
 * @class Auth0ConnectionImpl
 * @implements Auth0Connection
 */
class Auth0ConnectionImpl implements Auth0Connection {
  id: AuthenticationSocialProvider;

  connection: string;

  constructor(id: AuthenticationSocialProvider, connection: string) {
    this.id = id;
    this.connection = connection;
  }
}

/**
 * Vistaprint Auth0 settings
 *
 * @exports
 * @class VpAuth0Settings
 * @implements Auth0Setting
 */
export class VpAuth0Settings implements Auth0Setting {
  constructor(public auth0Settings: string) {}

  leeway = 60;

  audience = 'vistaprint';

  auth0Tenant = 'vistaprint';

  connections: Array<Auth0Connection> = [
    new Auth0ConnectionImpl(
      AuthenticationSocialProvider.Google,
      'google-oauth2'
    ),
    new Auth0ConnectionImpl(AuthenticationSocialProvider.Facebook, 'facebook'),
    new Auth0ConnectionImpl(AuthenticationSocialProvider.Apple, 'apple')
  ];
}
